import { SendingAddressesMap } from "src/views/AssetManagement/BatchApproveAllowance/contexts/PreviewContext";

export const areAllAddressesSelected = (
  sendingAddressesMap: SendingAddressesMap,
  walletMajorVersion: number,
) =>
  Array.from(sendingAddressesMap.values())
    .filter((item) => item.walletMajorVersion === walletMajorVersion)
    .every((info) => info.isSelected);

export const setAllAddressesSelection = (
  previousMap: SendingAddressesMap,
  isChecked: boolean,
) => {
  const nextMap = new Map(previousMap);
  nextMap.forEach((value, key) => {
    nextMap.set(key, {
      ...value,
      isSelected: isChecked,
    });
  });
  return nextMap;
};

export const setAllAddressesSelectionByWalletMajorVersion = (
  previousMap: SendingAddressesMap,
  isChecked: boolean,
  walletMajorVersion: number,
) => {
  const nextMap = new Map(previousMap);
  nextMap.forEach((value, key) => {
    if (value.walletMajorVersion !== walletMajorVersion) {
      return;
    }
    nextMap.set(key, {
      ...value,
      isSelected: isChecked,
    });
  });
  return nextMap;
};

export const setSingleAddressSelection = (
  previousMap: SendingAddressesMap,
  sendingAddress: string,
  isChecked: boolean,
) => {
  const currentAddressInfo = previousMap.get(sendingAddress);

  if (!currentAddressInfo) {
    return previousMap;
  }

  return new Map(previousMap).set(sendingAddress, {
    ...currentAddressInfo,
    isSelected: isChecked,
  });
};
